import type { SxProps, Theme } from '@mui/material/styles'

import colorTokens from '../../tokens/colors.ts'

const metricColours = colorTokens.metric
const neutralColours = colorTokens.global.neutral

export const titleColorUnselected: string = metricColours.default.cardTitle
export const titleColorSelected: string = metricColours.selected.cardTitle

export const borderAndHoverUnselected: SxProps<Theme> = {
  backgroundColor: metricColours.default.surface,
  borderColor: metricColours.default.border,
  '&:hover': {
    backgroundColor: metricColours.hover.surface,
    borderColor: metricColours.hover.border
  }
}

export const borderAndHoverSelected: SxProps<Theme> = {
  backgroundColor: metricColours.selected.surface,
  borderColor: metricColours.selected.border,
  '&:hover': {
    backgroundColor: metricColours.selected.surface,
    borderColor: metricColours.selected.border
  }
}

/** Selected chrome without hover interaction (pair with {@link borderAndHoverDisabled} for unselected). */
export const borderSelectedNoHover: SxProps<Theme> = {
  backgroundColor: metricColours.selected.surface,
  borderColor: metricColours.selected.border
}

export const borderAndHoverDisabled: SxProps<Theme> = {
  backgroundColor: metricColours.default.surface,
  borderColor: metricColours.default.border
}

export const loadingShell: SxProps<Theme> = {
  backgroundColor: neutralColours[500],
  borderColor: neutralColours[100]
}
